// ReviewerSelectionContext.tsx
import { createContext, useContext, useState } from 'react';
import { ISearchQueryItems } from 'src/api/queries';

interface ReviewerSelectionContextType {
  selectedReviewers: ISearchQueryItems[];
  toggleReviewer: (reviewer: ISearchQueryItems) => void;
}

const ReviewerSelectionContext = createContext<
  ReviewerSelectionContextType | undefined
>(undefined);

export const useReviewerSelection = () => {
  const context = useContext(ReviewerSelectionContext);
  if (!context) {
    throw new Error(
      'useReviewerSelection must be used within a ReviewerSelectionProvider'
    );
  }
  return context;
};

export const ReviewerSelectionProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [selectedReviewers, setSelectedReviewers] = useState<
    ISearchQueryItems[]
  >([]);

  const getReviewerEmail = (reviewer: ISearchQueryItems) => {
    return (
      reviewer.properties.find(
        p => p.propertyName === 'ReviewerPrimaryEmailAddress'
      )?.propertyValueString?.[0] || ''
    );
  };

  const toggleReviewer = (reviewer: ISearchQueryItems) => {
    const email = getReviewerEmail(reviewer);
    setSelectedReviewers(prev =>
      prev.some(r => getReviewerEmail(r) === email)
        ? prev.filter(r => getReviewerEmail(r) !== email)
        : [...prev, reviewer]
    );
  };

  return (
    <ReviewerSelectionContext.Provider
      value={{ selectedReviewers, toggleReviewer }}
    >
      {children}
    </ReviewerSelectionContext.Provider>
  );
};
